<template>
  <BCard class="min-h-[100vh]">
    <!-- Header with back button and title -->
    <div class="flex w-full justify-between items-center">
      <div class="flex gap-[12px] items-center">
        <BButton
          variant="primary"
          size="sm"
          class="rounded-[6px]"
          @click="$router.back()"
        >
          <img
            class="w-[20px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </BButton>
        <div class="text-black font-semibold text-[24px]">
          Pengajuan Akun Whitelisted - {{ platformInfo.name }}
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="mt-[24px]">
      <!-- Detail Pengajuan Card -->
      <div class="p-[20px] border rounded-[8px] bg-white">
        <!-- Grid Layout for Details -->
        <div class="flex flex-row gap-y-[20px] gap-x-[40px]">
          <div class="basis-3/4">
            <!-- Status -->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Status
                </span>
                <span>:</span>
              </div>
              <div>
                <span
                  class="px-[8px] py-[4px] rounded-xl text-center capitalize text-sm w-[90px] inline-block"
                  :class="getStatusClass(accountData.status)"
                >
                  {{ getStatusText(accountData.status) }}
                </span>
              </div>
            </div>

            <!-- Tanggal Proses -->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Waktu Proses
                </span>
                <span>:</span>
              </div>
              <div class="text-[#212529] text-[16px]">
                {{ processDate }}
              </div>
            </div>

            <!-- Tanggal Pengajuan -->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Waktu Pengajuan
                </span>
                <span>:</span>
              </div>
              <div class="text-[#212529] text-[16px]">
                {{ submitDate }}
              </div>
            </div>

            <!-- ID BM -->
            <div
              v-if="platform === 'meta'"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  ID Business Manager
                </span>
                <span>:</span>
              </div>
              <div class="flex items-center gap-[8px]">
                <div class="text-[#212529] text-[16px]">
                  {{ accountData.bm_id }}
                </div>
                <BButton
                  v-b-tooltip.hover
                  variant="link"
                  size="sm"
                  class="p-0"
                  title="Salin ID"
                  @click="copyToClipboard(accountData.bm_id)"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/copy.svg"
                    alt="k-copy"
                    width="16"
                    height="16"
                  >
                </BButton>
              </div>
            </div>

            <!-- Nama Partner-->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Nama Partner
                </span>
                <span>:</span>
              </div>
              <div class="text-[#212529] text-[16px]">
                {{ accountData.partner_name }}
              </div>
            </div>

            <!-- Email Partner -->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Email Partner
                </span>
                <span>:</span>
              </div>
              <div class="text-[#212529] text-[16px]">
                {{ accountData.partner_email }}
              </div>
            </div>

            <!-- Email Akun Google Ads -->
            <div
              v-if="platform === 'google'"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Email Akun Google Ads
                </span>
                <span>:</span>
              </div>
              <div class="flex items-center gap-[8px]">
                <div class="text-[#212529] text-[16px]">
                  {{ accountData.gmail }}
                </div>
                <BButton
                  v-b-tooltip.hover
                  variant="link"
                  size="sm"
                  class="p-0"
                  title="Salin Email"
                  @click="copyToClipboard(accountData.gmail)"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/copy.svg"
                    alt="k-copy"
                    width="16"
                    height="16"
                  >
                </BButton>
              </div>
            </div>
            <!-- BC ID -->
            <div
              v-if="platform === 'tiktok'"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  ID Business Center
                </span>
                <span>:</span>
              </div>
              <div class="flex items-center gap-[8px]">
                <div class="text-[#212529] text-[16px]">
                  {{ accountData.bc_id }}
                </div>
                <BButton
                  v-b-tooltip.hover
                  variant="link"
                  size="sm"
                  class="p-0"
                  title="Salin ID"
                  @click="copyToClipboard(accountData.bc_id)"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/copy.svg"
                    alt="k-copy"
                    width="16"
                    height="16"
                  >
                </BButton>
              </div>
            </div>

            <!-- Link Konten Produk -->
            <div
              v-if="['meta', 'tiktok'].includes(platform)"
              class="flex items-start mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Link Konten Produk
                </span>
                <span>:</span>
              </div>
              <a
                :href="accountData.product_link"
                target="_blank"
                class="text-[#007BFF] text-[16px] hover:underline"
              >
                {{ accountData.product_link }}
              </a>
            </div>

            <div
              v-if="isGooglePlatform"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Link Landing Page
                </span>
                <span>:</span>
              </div>
              <a
                :href="accountData.product_landing_page_link"
                target="_blank"
                class="text-[#007BFF] text-[16px] hover:underline"
              >
                {{ accountData.product_landing_page_link }}
              </a>
            </div>

            <!-- Nominal Top Up Awal -->
            <div class="flex mb-[4px]">
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Nominal Awal Top Up
                </span>
                <span>:</span>
              </div>

              <div class="flex items-center gap-[8px]">
                <div class="text-[#212529] text-[16px]">
                  {{ IDR(accountData.nominal_top_up) }}
                </div>
                <BButton
                  v-if="
                    accountData.status !== 'accepted' && accountData.nominal_top_up > 0 && !isGooglePlatform
                  "
                  variant="primary"
                  class="bg-[#FFF5E9] text-[#FBA63C] !px-[6px] !py-[4px] !text-[12px] font-normal"
                  @click="$bvModal.show('modal-refund-balance')"
                >
                  Kembalikan Saldo
                </BButton>
              </div>
            </div>
            <!-- Duration Day -->
            <div
              v-show="isGooglePlatform"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row align-items-start w-[250px] justify-between mr-[8px]"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Durasi Berlangganan ({{ accountData.subscription_data.duration_day }} Hari)
                </span>
                <span>:</span>
              </div>

              <div
                class="flex items-center gap-[8px] flex-col align-items-start"
              >
                <div class="text-[#212529] text-[16px]">
                  {{ IDR(accountData.subscription_data.nominal) }}
                </div>
                <BButton
                  v-if="
                    accountData.status !== 'accepted' &&
                      (accountData.subscription_data.duration_day > 0 && accountData.subscription_data.nominal)
                  "
                  variant="primary"
                  class="bg-[#FFF5E9] text-[#FBA63C] !px-[6px] !py-[4px] !text-[12px] font-normal"
                  @click="$bvModal.show('modal-refund-balance')"
                >
                  Kembalikan Saldo
                </BButton>
              </div>
            </div>

            <!-- Ad Account ID -->
            <div
              v-if="isMetaCpas"
              class="flex mb-[4px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Ad Account ID
                </span>
                <span>:</span>
              </div>
              <span class="text-[16px]">
                {{ accountData.ad_account_id }}
              </span>
            </div>

            <!-- Bukti Form CPAS -->
            <div
              v-if="isMetaCpas"
              class="flex items-center mb-[8px]"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Bukti Form CPAS
                </span>
                <span>:</span>
              </div>
              <b-button
                v-show="!!accountData.partner_cpas_proof_url"
                variant="outline-primary"
                :href="accountData.partner_cpas_proof_url || '#'"
                target="_blank"
                size="sm"
              >
                <span class="k-document-text text-[#F95031]! text-[14px]" />
                Lihat Bukti Screenshot
              </b-button>
            </div>

            <!-- Bukti Akun Ditautkan Shopee -->
            <div
              v-if="isMetaCpas"
              class="flex items-start"
            >
              <div
                class="flex flex-row mr-[8px] items-center"
              >
                <span class="text-[#6C757D] text-[14px] inline-block w-[300px]">
                  Bukti Akun Ditautkan Shopee
                </span>
                <span>:</span>
              </div>
              <div class="flex flex-col gap-[8px]">
                <b-button
                  v-for="(url, index) in adminCpasProofUrls"
                  :key="url"
                  variant="outline-primary"
                  :href="url"
                  target="_blank"
                  size="sm"
                >
                  <span class="k-document-text text-[#F95031]! text-[14px]" />
                  Lihat Bukti Screenshot {{ index + 1 }}
                </b-button>
              </div>
            </div>
          </div>
          <div
            v-show="accountData.status === 'on review' || isProcessCpas"
            class="basis-1/4 w-full"
          >
            <div
              v-if="!accountData.partner_cpas_proof_url || !accountData.admin_cpas_proof_url"
              class="grid grid-cols-2 gap-[8px]"
            >
              <BButton
                variant="light"
                size="md"
                class="px-[24px] py-[8px] text-[#DC3545] border-[#DC3545] hover:bg-[#DC3545] hover:text-white rounded"
                :disabled="isRejected || loading || (isProcessCpas && !accountData.partner_cpas_proof_url)"
                @click="$bvModal.show('modal-confirm-rejection')"
              >
                Tolak
              </BButton>
              <BButton
                v-if="isFinalApprove"
                variant="primary"
                size="md"
                class="px-[24px] py-[8px] bg-[#DC3545] border-[#DC3545] hover:bg-[#C82333] text-white rounded"
                :disabled="loading || isRejectedAtCpasFlowStep2"
                @click="$bvModal.show('modal-final-approval')"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="me-2"
                />
                Final Approve
              </BButton>
              <BButton
                v-else
                variant="primary"
                size="md"
                class="px-[24px] py-[8px] bg-[#DC3545] border-[#DC3545] hover:bg-[#C82333] text-white rounded"
                :disabled="loading || isProcessCpas"
                @click="handleOpenConfirmModal"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="me-2"
                />
                {{ confirmButton.label }}
              </BButton>
            </div>
          </div>
        </div>
      </div>

      <!-- Riwayat Pengajuan Section -->
      <div class="mt-[32px]">
        <h3 class="text-[#212529] text-[18px] font-semibold mb-[16px]">
          Riwayat Pengajuan
        </h3>

        <div class="border rounded-[8px] overflow-hidden">
          <BTable
            id="request-history-table"
            :items="requestHistory"
            :fields="tableFields"
            striped
            hover
            show-empty
            empty-text="Belum ada riwayat pengajuan"
            class="table-head-capitalize"
          >
            <!-- No Column -->
            <template #cell(index)="data">
              <span class="text-[#212529]">{{ data.index + 1 }}</span>
            </template>

            <!-- Tanggal Pengajuan Column -->
            <template #cell(request_date)="data">
              <div class="text-[#333333] flex flex-col">
                <span>{{ newLineSplitDateTime(data.item.created_at)[0] }}</span>
                <span class="text-[#737373] text-sm">{{ newLineSplitDateTime(data.item.created_at)[1] }} WIB</span>
              </div>
            </template>

            <!-- Admin Approver -->
            <template #cell(admin_name)="data">
              <span class="text-[#212529]">{{
                data.item.admin_name || '-'
              }}</span>
            </template>

            <!-- Status Column -->
            <template #cell(status)="data">
              <span
                class="px-[8px] py-[4px] rounded-xl text-center capitalize text-sm w-[90px] inline-block"
                :class="getStatusClass(data.item.status)"
              >
                {{ getStatusText(data.item.status) }}
              </span>
            </template>

            <!-- Alasan Penolakan Column -->
            <template #cell(rejection_reason)="data">
              <BButton
                v-if="data.item.status === 'rejected'"
                variant="link"
                size="sm"
                class="text-[#007BFF] p-0 font-normal !underline"
                @click="showRejectionDetail(data.item)"
              >
                Detail Penolakan
              </BButton>
              <span
                v-else
                class="text-[#6C757D]"
              >-</span>
            </template>
          </BTable>
        </div>
      </div>
    </div>
    <!-- Modal Konfirmasi Pengembalian Saldo -->
    <ModalRefundBalance
      id="modal-refund-balance"
      :refund="refundBalance"
      @confirm-refund="handleConfirmRefund"
    />

    <!-- Modal Konfirmasi Persetujuan -->
    <ModalConfirmApproval
      :validation-error="submitValidationError"
      :platform="platform"
      @confirm-approval="handleConfirmApproval"
    />

    <!-- Modal Konfirmasi Penolakan -->
    <ModalConfirmRejection
      :initial-reason="rejectionReason"
      @confirm-rejection="handleConfirmRejection"
    />

    <ModalFormRejected
      id="modal-form-rejected"
      :message="messageRejection"
    />

    <ModalContinueCPASForm
      id="modal-continue-cpas-form"
      :validation-error="submitValidationError"
      @continue-to-cpas="handleConfirmApproval"
    />

    <ModalFinalApproval
      id="modal-final-approval"
      @final-approve="handleConfirmApproval"
    />
  </BCard>
</template>
<script>
import { DAY_MONTH_YEAR_COMMA_TIME, FULL_DATE_TIME } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import ModalConfirmApproval from './ModalConfirmApproval.vue'
import ModalConfirmRejection from './ModalConfirmRejection.vue'
import ModalRefundBalance from './ModalRefundBalance.vue'
import ModalFormRejected from './ModalFormRejected.vue'
import ModalContinueCPASForm from './ModalContinueCPASForm.vue'
import ModalFinalApproval from './ModalFinalApproval.vue'

export default {
  name: 'SetupAccount',
  components: {
    ModalConfirmApproval,
    ModalConfirmRejection,
    ModalRefundBalance,
    ModalFormRejected,
    ModalContinueCPASForm,
    ModalFinalApproval,
  },
  data() {
    return {
      IDR,
      DAY_MONTH_YEAR_COMMA_TIME,
      loading: false,
      showRejectionModal: false,
      selectedRejection: null,
      accountData: null,
      requestHistory: null,
      tableFields: [
        {
          key: 'index',
          label: 'No',
          class: 'text-center',
          thClass: 'text-center bg-[#F8F9FA] font-medium text-[#495057]',
          tdClass: 'align-middle',
        },
        {
          key: 'request_date',
          label: 'Waktu',
          thClass: 'bg-[#F8F9FA] font-medium text-[#495057]',
          tdClass: 'align-middle',
        },
        {
          key: 'admin_name',
          label: 'Admin Approver',
          thClass: 'bg-[#F8F9FA] font-medium text-[#495057]',
          tdClass: 'align-middle',
        },
        {
          key: 'status',
          label: 'Status',
          class: 'text-center',
          thClass: 'text-center bg-[#F8F9FA] font-medium text-[#495057]',
          tdClass: 'align-middle text-center',
        },
        {
          key: 'rejection_reason',
          label: 'Catatan Penolakan',
          class: 'text-center',
          thClass: 'text-center bg-[#F8F9FA] font-medium text-[#495057]',
          tdClass: 'align-middle text-center',
        },
      ],
      platformConfig: {
        meta: {
          name: 'Meta',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        },
        google: {
          name: 'Google',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/google.svg',
        },
        tiktok: {
          name: 'TikTok',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
        },
      },
      confirmActionButton: {
        cpas: {
          label: 'Lanjutkan ke CPAS',
          modal: 'modal-continue-cpas-form',
        },
        whitelist: {
          label: 'Setujui',
          modal: 'modal-confirm-approval',
        },
      },

      rejectionReason: '',
      messageRejection: '',
      submitValidationError: {
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      },
    }
  },
  computed: {
    isGooglePlatform() {
      return this.$route.query.platform === 'google'
    },
    platform() {
      return this.$route.query.platform || 'meta'
    },
    partnerId() {
      return this.$route.query.id
    },
    platformInfo() {
      return this.platformConfig[this.platform] || this.platformConfig.meta
    },
    submitDate() {
      return this.accountData?.created_at ? `${this.DAY_MONTH_YEAR_COMMA_TIME(this.accountData.created_at)} WIB` : '-'
    },
    processDate() {
      return this.accountData?.processed_at ? `${this.DAY_MONTH_YEAR_COMMA_TIME(this.accountData.processed_at)} WIB` : '-'
    },
    refundBalance() {
      if (this.platform === 'meta') return this.accountData.nominal_top_up
      return (
        this.accountData.nominal_top_up
        + this.accountData.subscription_data.nominal
      )
    },
    subscriptionStatus() {
      return ['google', 'tiktok'].includes(this.platform)
    },
    confirmButton() {
      return this.confirmActionButton[this.accountData.ad_account_type || 'whitelist']
    },
    isMetaCpas() {
      return this.platform === 'meta' && this.accountData.ad_account_type === 'cpas'
    },
    isFinalApprove() {
      return !!this.accountData.partner_cpas_proof_url && !this.accountData.admin_cpas_proof_url
    },
    isRejected() {
      return this.accountData.status === 'rejected'
    },
    isProcessCpas() {
      return this.accountData.status === 'on process cpas'
    },
    isRejectedAtCpasFlowStep2() {
      return this.isRejected && this.accountData.partner_cpas_proof_url
    },
    adminCpasProofUrls() {
      return this.accountData.admin_cpas_proof_url ? this.accountData.admin_cpas_proof_url.split(',') : []
    },
  },
  async mounted() {
    this.validatePlatform()
    await this.loadAccountDataRequest()
    await this.loadHistoryAccountRequest()
  },
  methods: {
    /**
     * Split date and time into an array with two elements: [date, time]
    */
    newLineSplitDateTime(stringDateTime) {
      return FULL_DATE_TIME(stringDateTime).split(' - ')
    },
    validatePlatform() {
      const validPlatforms = ['meta', 'google', 'tiktok']
      if (!validPlatforms.includes(this.platform)) {
        this.$router.replace(
          `/komads/setup-whitelisted?id=${this.partnerId}&platform=${this.platform}`,
        )
      }
    },
    handleOpenConfirmModal() {
      this.resetSubmitValidationError()
      this.$bvModal.show(this.confirmButton.modal)
    },
    async loadAccountDataRequest() {
      try {
        const response = await newAxiosIns.get(
          `komads/api/v1/admin/whitelist_account_requests/${this.partnerId}/detail`,
        )
        this.accountData = response.data.data
      } catch (error) {
        this.$toast_error({
          message: 'Gagal memuat data pengajuan akun whitelisted',
        })
      }
    },
    async loadHistoryAccountRequest() {
      try {
        const response = await newAxiosIns.get(
          `komads/api/v1/admin/whitelist_account_requests/${this.partnerId}/history`,
        )
        this.requestHistory = response.data.data || []
      } catch (error) {
        this.$toast_error({
          message: 'Gagal memuat riwayat pengajuan akun whitelisted',
        })
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast_success({
            message: 'Teks berhasil disalin',
          })
        })
        .catch(() => {
          this.fallbackCopyToClipboard(text)
        })
    },

    /**
     * Get status class for badge
     */
    getStatusClass(status) {
      const variants = {
        accepted: 'bg-[#E6F6EB] text-[#30A46C]',
        'on review': 'bg-[#FFD19A] text-[#CC4E00]',
        rejected: 'bg-[#FEEBEC] text-[#E5484D]',
        'on process cpas': 'bg-[#E6F4FE] text-[#0090FF]',
      }

      return variants[status] || 'bg-gray-100 text-[#828282]'
    },

    /**
     * Get display text for status
     */
    getStatusText(status) {
      const variants = {
        accepted: 'Accepted',
        'on review': 'Review',
        rejected: 'Rejected',
        'on process cpas': 'CPAS',
      }
      return variants[status] || status
    },

    showRejectionDetail(item) {
      this.messageRejection = item.notes
      this.$bvModal.show('modal-form-rejected')
    },

    /**
     * Handler for confirm-approval event from ModalConfirmApproval component
     * @param {Object} form - Form data from modal containing account_name
     */
    async handleConfirmApproval(form) {
      if (this.loading) return

      const formData = new FormData()
      formData.append('status', form.status)
      formData.append('whitelist_account_name', form.account_name)
      formData.append('system_bm_id', form.system_bm_id)
      formData.append('ad_account_id', form.ad_account_id)
      if (this.isFinalApprove && form.file) {
        form.file.forEach(file => {
          formData.append('file', file)
        })
      }

      this.loading = true
      await newAxiosIns
        .put(
          `komads/api/v1/admin/whitelist_account_requests/${this.accountData.id}/update`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
        .then(() => {
          this.$toast_success({
            message: this.isFinalApprove ? 'File berhasil diupload' : 'Akun whitelisted berhasil ditambahkan',
          })
          this.getNotification()
          if (this.isFinalApprove) this.$bvModal.hide('modal-final-approval')
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            const errorMessage = error.response.data?.meta.message || ''

            // account_name validation error handling
            if (errorMessage.includes('account already exist')) {
              this.submitValidationError.account_name = 'Nama sudah digunakan, silahkan gunakan nama lain.'
            } else if (errorMessage.includes('ad account id not valid')) { // ad_account_id error input
              this.submitValidationError.ad_account_id = 'ID Ad Account Tidak Valid.'
            } else if (errorMessage.includes('bm limit exceeded')) { // system_bm_id error input
              this.submitValidationError.system_bm_id = 'Kuota Business Manager Sudah Penuh.'
            } else {
              this.$toast_error({
                message: errorMessage || 'Gagal melakukan approval akun whitelisted',
              })
            }

            this.$bvModal.show(this.isFinalApprove ? 'modal-final-approval' : this.confirmButton.modal)
          } else {
            this.$toast_error({
              message: this.isFinalApprove ? 'File gagal diupload' : 'Gagal melakukan approval akun whitelisted',
            })
          }
        })
        .finally(() => {
          this.loadAccountDataRequest()
          this.loadHistoryAccountRequest()
          this.loading = false
        })
    },

    /**
     * Handler for confirm-rejection event from ModalConfirmRejection component
     * @param {String} reason - The rejection reason
     */
    async handleConfirmRejection(reason) {
      const formData = new FormData()
      formData.append('status', 'rejected')
      formData.append('notes', reason)

      await newAxiosIns
        .put(
          `komads/api/v1/admin/whitelist_account_requests/${this.accountData.id}/update`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
        .then(() => {
          this.$toast_success({
            message: 'Akun whitelisted berhasil ditolak',
          })
          this.getNotification()
        })
        .catch(() => {
          this.$toast_error({
            message: 'Gagal menolak akun whitelisted',
          })
        })
        .finally(() => {
          this.rejectionReason = ''
          this.loadAccountDataRequest()
          this.loadHistoryAccountRequest()
        })
    },

    async handleConfirmRefund() {
      await newAxiosIns
        .post(
          `komads/api/v1/admin/whitelist_account_requests/${this.accountData.id}/refund`,
        )
        .then(() => {
          this.$toast_success({
            message: 'Pengembalian saldo sudah berhasil',
          })
          this.getNotification()
        })
        .catch(error => {
          this.$toast_error({
            message:
              'Isi ulang saldo Anda terlebih dahulu, lalu Anda dapat melakukan perubahan segera!',
          })
          this.$bvModal.show('modal-refund-balance')
        })
        .finally(() => {
          this.rejectionReason = ''
          this.loadAccountDataRequest()
          this.loadHistoryAccountRequest()
        })
    },

    getNotification() {
      this.$store.dispatch('komadsWhitelist/fetchPendingCount')
    },

    /**
     * Resets the submit validation error.
     * @returns {void}
     */
    resetSubmitValidationError() {
      this.submitValidationError = {
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }
    },
  },
}
</script>

<style scoped>
/* Custom styling for form */
.form-group label {
  font-weight: 500;
  margin-bottom: 8px;
}

.form-control:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);
}

.btn-primary {
  background-color: #7367f0;
  border-color: #7367f0;
}

.btn-primary:hover {
  background-color: #5e50ee;
  border-color: #5e50ee;
}

.btn-outline-secondary {
  color: #828282;
  border-color: #828282;
}

.btn-outline-secondary:hover {
  background-color: #828282;
  border-color: #828282;
  color: white;
}

.bg-\[\#E6F6EB\] {
  background-color: #E6F6EB;
}

.text-\[\#30A46C\] {
  color: #30A46C;
}

.bg-\[\#FFD19A\] {
  background-color: #FFD19A;
}

.text-\[\#CC4E00\] {
  color: #CC4E00;
}

.bg-\[\#FEEBEC\] {
  background-color: #FEEBEC;
}

.text-red-\[\#E5484D\] {
  color: #E5484D;
}

.bg-\[\#E6F4FE\] {
  background-color: #E6F4FE;
}

.text-\[\#0090FF\] {
  color: #0090FF;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.text-\[\#828282\] {
  color: #828282;
}
</style>
